import { ScreenLoading } from '@ui-components/neo.tax';
import * as React from 'react';

import { useAscPageLockStatus } from '@neo.tax/asc/hooks';
import { PageLayout, type PageLayoutProps } from '@neo.tax/shared';

export const AscLockPageLayout: React.FC<
  Omit<PageLayoutProps, 'locked' | 'lockedReason'> & { forceUnlock?: boolean; disableIfOngoingSync?: boolean }
> = ({ children, disableIfOngoingSync, forceUnlock, lockButtons, ...rest }) => {
  // The admin period lock is the whole point of this layout. Data Sources deletes cost uploads and
  // replaces the ticketing data ASC projects derive from, so a closed period has to reach it too.
  const { loading: loadingPageLockStatus, pageLockStatus } = useAscPageLockStatus({
    disableIfOngoingSync,
    disableIfPeriodLocked: true,
  });

  // Nothing behind these pages turns a write away, so they cannot be handed over before the lock
  // status is known: rendering now and fading a moment later leaves a window in which a closed
  // period looks editable and the writes made in it land. `forceUnlock` opts out of the lock
  // entirely, so it has nothing to wait for.
  if (loadingPageLockStatus && !forceUnlock) {
    return <ScreenLoading />;
  }

  return (
    <PageLayout
      locked={forceUnlock ? false : pageLockStatus.locked}
      lockButtons={
        forceUnlock ? (
          []
        ) : (
          <>
            {pageLockStatus.lockButtons}
            {lockButtons}
          </>
        )
      }
      lockedReason={forceUnlock ? '' : pageLockStatus.lockedReason}
      {...rest}
    >
      {children}
    </PageLayout>
  );
};
